import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useMainContext } from "../../../Context";
import { blogs, blogSingle } from "../../../Utils/Apis";

export const useBlogList = ({ filters }) => {
  const [data, setData] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const { post } = useMainContext();
  const getData = async () => {
    setLoading(true);
    const { data } = await post(blogs, {
      ...createObjFilter(),
    });
    setData(data);
    setLoading(false);
  };
  const createObjFilter = () => {
    let obj = {};
    filters.map(element => {
      if (searchParams.get(element.key)) {
        obj = { ...obj, [element.key]: searchParams.get(element.key) };
      }
    });
    return obj;
  };

  useEffect(() => {
    getData();
  }, [searchParams]);
  const changeObj = (key, value) => {
    let obj = {};
    filters.map(element => {
      if (searchParams.get(element.key)) {
        obj = { ...obj, [element.key]: searchParams.get(element.key) };
      }
    });
    setSearchParams({ ...obj, [key]: value });
  };
  return { loading, data, searchParams, setSearchParams, changeObj };
};
export const useBlogSingle = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const { post } = useMainContext();
  const { slug } = useParams();
  const getData = async () => {
    setLoading(true);
    const { data } = await post(blogSingle, { slug });
    setData(data);
    setLoading(false);
  };
  const renderSlug = () => {
    let slugList = slug && slug.split("-");
    let res = "";
    slugList &&
      slugList.map(ch => {
        if (!(typeof ch == "number")) {
          res += " " + ch;
        }
      });
    return res;
  };

  useEffect(() => {
    getData();
  }, []);

  return { loading, data, renderSlug, slug };
};
